import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import {rangeDates} from '../../utils';

const DatePickerWrapper = ({dates}) => {
  const highlightDates = rangeDates(dates);
  const minDate = dates.length >= 1 ? moment(dates[0].startDate) : null;
  const maxDate = dates.length >= 1 ? moment(dates[dates.length - 1].endDate) : null;
  return (
    <DatePicker
      showDisabledMonthNavigation
      minDate={minDate ? moment(minDate).toDate() : null}
      maxDate={maxDate ? moment(maxDate).toDate() : null}
      inline
      selected={minDate ? moment(minDate).toDate() : null}
      highlightDates={highlightDates}
      locale='es'
    />
  );
};

export default DatePickerWrapper;
